import I18n from 'I18n';
import { OPEN } from 'customer-data-objects/ticket/TicketStageStatusOptions';
import { useCallback } from 'react';
import { getDiscountCodeErrorMessage, setDiscountCodeErrorMessage } from '../../state/DiscountCode/discountCodeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { setErrorMessages } from '../../state/errorMessagesSlice';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const DiscountCodeInput = ({
  status
}) => {
  const reduxDispatch = useDispatch();
  const {
    formState,
    dispatch
  } = usePaymentFormContext();
  const discountCodeError = formState.get('discountCodeError');
  const isDiscountCodeApplied = formState.get('isDiscountCodeApplied');
  const discountCode = formState.get('discountCode');
  const discountCodeErrorMessage = useSelector(getDiscountCodeErrorMessage);
  const handleDiscountCodeChange = useCallback(event => {
    reduxDispatch(setDiscountCodeErrorMessage(''));
    reduxDispatch(setErrorMessages({
      invalidDiscountCode: {
        isError: false
      }
    }));
    dispatch({
      type: 'setDiscountCode',
      data: event.target.value
    });
    if (discountCodeError) {
      dispatch({
        type: 'setDiscountCodeError',
        data: false
      });
    }
  }, [dispatch, discountCodeError, reduxDispatch]);
  return /*#__PURE__*/_jsx(FormControl, {
    error: !!discountCodeErrorMessage,
    validationMessage: discountCodeErrorMessage,
    paddingBlockStart: "0",
    paddingBlockEnd: "0",
    children: /*#__PURE__*/_jsx(TextInput, {
      readOnly: status !== OPEN || isDiscountCodeApplied,
      "data-test-id": "discount-code-input",
      placeholder: I18n.text('payments.enterDiscountCodePlaceHolder'),
      value: discountCode,
      onChange: handleDiscountCodeChange,
      use: "on-dark"
    })
  });
};
export default DiscountCodeInput;